var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({staticClass:"text-capitalize mr-auto",attrs:{"outlined":!_vm.confirmState,"color":"error"},on:{"click":function($event){return _vm.handleCancel()}}},'v-btn',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }